const routes = {
    root: "/",
    generativeAI: "/generative-ai",
    profile: "/profile",
    leaderSpeaks: "/leader-speak",
    companyWithHearts: "company-with-heart",
    events: "/events",
    birthdays: "/birthday",
    announcements: "/announcements",
    newJoiners: "/new-joiners",
    promotions: "/promotions",
    accolades: "/accolades",
    birthAnnouncements: "/birth-announcements",
    anniversaries: "/anniversaries",
    associateSpotlight: "/associate-spotlight",
    imageSlider: "/image-slider",
    stories: "/stories",
    awards: "/awards",
    more: "/more",
    jobDescriptionView: "/job-description/",
    jobReferral: "/job-referral",
    organizationTree: "/organization-tree",
    weddings: "/weddings",
    contactDirectory: "/contact-directory",
    findAssociate: "/find-associate",
    feedView: "/feed/",
    internalJobs: "/internal-jobs",
    importantLinks: "/important-links",
    myFavorite: "/my-favorite",
    settings: "/settings",
    userViewProfileView: "/user-view-profile/",
};

export default routes;